export const messages = {
  'zh-CN': {
    common: {
      brand: 'Cloudflare Tools',
      brandTag: '公开网页操作 + VIP API 自动化平台',
      console: '控制台',
      docs: 'API 文档',
      pricing: '套餐价格',
      memberCenter: '会员中心',
      login: '登录',
      register: '注册',
      logout: '退出登录',
      getStarted: '立即开始',
      viewDocs: '查看文档',
      launchConsole: '打开控制台',
      save: '保存',
      cancel: '取消',
      search: '搜索',
      generate: '生成',
      revoke: '吊销',
      copy: '复制',
      active: '启用中',
      recommended: '推荐',
      all: '全部',
      footerProduct: '产品',
      footerWorkspace: '工作区',
      contactUs: '联系方式',
      telegram: 'Telegram',
      telegramAction: '通过 Telegram 联系',
      localModeNotice:
        '普通用户无需注册即可直接使用网页控制台，Cloudflare Token 默认只保存在浏览器本地，不写入数据库。VIP 会员可选择在会员中心加密保存专用 API Token，用于服务端 API 调用。',
    },
    nav: {
      home: '首页',
      pricing: '套餐价格',
      docs: 'API 文档',
      geo: 'GEO 说明',
      member: '会员中心',
      console: '控制台',
    },
    home: {
      badge: '中英双语 / 网页直用 / 会员 API',
      title: '把 Cloudflare 运维工具做成可公开使用、可会员调用、可直接上线的双语产品',
      description:
        '普通用户不注册也能直接在网页控制台完成 Cloudflare 操作，VIP 会员则可通过 API Key 调用所有接口，并选择每次携带 Cloudflare Token 或加密保存后直连平台 API。',
      primaryCta: '进入控制台',
      secondaryCta: '查看 API 文档',
      stats: [
        { label: '公开网页模式', value: '免注册' },
        { label: '文档示例', value: 'PHP / Python' },
        { label: '会员开通', value: 'Telegram 联系' },
      ],
      sections: {
        featuresTitle: '核心能力',
        features: [
          {
            title: '游客网页直接可用',
            description: '网页控制台可以直接操作 DNS、SSL、安全、Workers 等能力，不要求先注册会员。',
          },
          {
            title: 'Cloudflare 凭证默认不入库',
            description: '普通网页模式下的 Cloudflare Token 仅保存在浏览器本地，不会写入你的会员数据库。',
          },
          {
            title: 'VIP 会员开放全部 API',
            description: '付费会员可生成 API Key，调用完整 `/api/v1/*` 接口，并按需传入或保存 Cloudflare Token。',
          },
          {
            title: '完整在线文档',
            description: '接口按 Zones、DNS、SSL/TLS、Security、Workers & Pages 分组展示，并附 PHP / Python 示例。',
          },
        ],
        productKicker: '系统结构',
        productTitle: '前台公开可用，后台会员可集成',
        productDescription:
          '这套系统同时覆盖了网页运维场景和 API 自动化场景。前台用于公开获客和直接使用，会员中心负责人工开通、API Key 和加密凭证管理。',
        productBullets: [
          '公开站点：首页 / 套餐页 / 文档页 / GEO 说明页 / 会员中心',
          '游客网页模式：Cloudflare Token 仅保存在浏览器本地',
          'VIP API 模式：会员可保存专用 Token，服务端转发全部接口',
        ],
        referenceKicker: '接口能力',
        docsTitle: '统一的 Cloudflare API 接入层',
        docsDescription:
          '你不需要再为每类 Cloudflare 能力单独整理鉴权、示例和调用方式，平台已经把能力分区、参数说明和示例代码整理好。',
        referenceBullets: [
          'Zones 与账户选择',
          'DNS 增删改查与批量操作',
          'SSL / TLS 模式与策略',
          'Security / WAF / Workers / Pages',
        ],
      },
      launchKicker: '上线形态',
      ctaTitle: '已适合部署到 Cloudflare Pages',
      ctaDescription:
        '公开页面、会员体系、Pages Functions API、D1 和 KV 已经串联好。接入真实密钥后即可作为 Cloudflare Pages 全栈项目上线，VIP 开通通过 Telegram 人工处理。',
      searchKicker: '中文 SEO / GEO 重点',
      searchTitle: '让搜索引擎和 AI 摘要更容易理解你这个工具站',
      searchDescription:
        '首页和公开页面现在会更明确地表达这是一个面向中文用户的 Cloudflare 管理工具平台，覆盖 DNS、SSL/TLS、安全规则、国家访问限制、Workers、Pages 和 API 自动化。',
      searchTerms: [
        'Cloudflare 中文工具站与运维平台',
        'Cloudflare DNS 管理、批量解析与域名配置',
        'Cloudflare SSL / TLS 模式切换与批量设置',
        'Cloudflare 安全规则、WAF 与国家访问限制',
        'Cloudflare Workers 绑定、Pages 部署与会员 API 自动化',
      ],
      useCasesKicker: '典型场景',
      useCasesTitle: '适合站群、代维、SaaS 和批量运维',
      useCases: [
        {
          title: '批量管理多个 Cloudflare 域名',
          description: '适合同时处理多个站点的 DNS、SSL/TLS、安全规则和 Workers 路由，减少重复点击和账号切换。',
        },
        {
          title: '用中文界面快速完成 Cloudflare 常用操作',
          description: '普通用户无需注册即可直接打开网页控制台，快速配置解析、证书和基础安全策略。',
        },
        {
          title: '把 Cloudflare 操作整合进脚本或自有系统',
          description: 'VIP 会员可通过 API Key 接入统一接口，把 DNS、SSL、安全和 Workers 操作接入自动化任务。',
        },
      ],
      faqKicker: '常见问题',
      faqTitle: '中文用户最常问的 4 个问题',
      faqs: [
        {
          q: 'Cloudflare Tools 主要能做哪些事情？',
          a: '它主要用于管理 Cloudflare DNS、SSL/TLS、安全规则、国家访问限制、Workers 路由与 Pages 相关操作，同时支持会员 API 自动化。',
        },
        {
          q: '没有注册账号也能用吗？',
          a: '可以。普通用户无需注册即可直接使用网页控制台；只有需要 API Key、配额和加密 Token 存储时，才需要升级 VIP。',
        },
        {
          q: '这个工具适合中文用户吗？',
          a: '适合。公开页面、文档和核心说明都为中文 SEO 和中文使用习惯做了优化，同时保留英文切换能力。',
        },
        {
          q: '是否支持批量 Cloudflare 运维？',
          a: '支持，项目已经覆盖批量 DNS、批量 SSL/TLS、批量域名接入、批量 Workers 绑定，以及安全规则相关能力。',
        },
      ],
    },
    pricing: {
      title: '套餐价格',
      description: '网页控制台对普通用户开放，API 调用能力只对 VIP 会员开放。需要开通或续费时，请通过 Telegram 人工联系。',
      plans: [
        {
          id: 'free',
          name: 'Free Web',
          price: '$0',
          blurb: '适合直接在网页里操作 Cloudflare，不需要注册，不记录你的 Cloudflare 凭证到数据库。',
          features: ['无需注册即可使用网页控制台', 'Cloudflare Token 默认只保存在浏览器', '适合手动管理 DNS / SSL / 安全设置', '不包含会员 API 调用权限'],
          badge: '',
          ctaLabel: '直接打开控制台',
          ctaTo: '/console',
        },
        {
          id: 'vip_yearly',
          name: 'VIP Yearly',
          price: '$130 / year',
          blurb: '适合需要稳定 API 接入、脚本自动化和多项目复用的个人或团队。',
          features: ['生成会员 API Key 调用全部接口', '支持每次请求携带 Cloudflare Token', '支持加密保存专用 Cloudflare Token', '在线文档附 PHP / Python 示例'],
          badge: 'recommended',
          ctaLabel: '联系 Telegram 开通',
          ctaTo: '/member',
        },
        {
          id: 'vip_lifetime',
          name: 'VIP Lifetime',
          price: '$600',
          blurb: '适合长期运营、多站点和高频自动化场景，一次开通长期可用。',
          features: ['终身使用会员 API 能力', '同样支持保存加密 Cloudflare Token', '适合长期脚本、SaaS 或代理业务集成', '省去续费管理'],
          badge: '',
          ctaLabel: '联系 Telegram 开通',
          ctaTo: '/member',
        },
      ],
    },
    member: {
      title: '会员中心',
      description: 'VIP 会员用于 API 接入，不影响普通用户直接使用网页控制台。',
      registerTitle: '创建会员账号',
      loginTitle: '登录会员账号',
      name: '姓名',
      company: '公司 / 团队',
      email: '邮箱',
      password: '密码',
      plan: '目标套餐',
      registerAction: '注册会员账号',
      loginAction: '登录会员中心',
      localMode: '普通用户可以直接使用网页控制台；只有需要 API 自动化时，才需要注册并升级 VIP。',
      dashboardTitle: '会员面板',
      billingTitle: 'VIP 开通与续费',
      billingDescription: '选择目标套餐后，通过 Telegram 联系人工开通或续费。当前站点不提供 Stripe 自助支付。',
      apiKeysTitle: 'API Key 管理',
      savedTokenTitle: '已保存的 Cloudflare Token',
      savedTokenDescription:
        '这是给 VIP API 模式使用的服务端凭证。它与网页控制台本地存储分离，保存后会加密写入 D1 对应的会员凭证表。',
      savedTokenLabel: 'Cloudflare API Token',
      savedTokenAlias: '凭证备注',
      savedTokenPlaceholder: '粘贴你的 Cloudflare API Token',
      savedTokenAliasPlaceholder: '例如 Production Account Token',
      saveTokenAction: '保存加密 Token',
      deleteTokenAction: '删除已保存 Token',
      savedTokenEmpty: '你还没有保存专用 Cloudflare Token。API 仍然可以通过每次请求传 `X-CF-Token` 来使用。',
      savedTokenHint: '保存后，会员 API 可以不再每次附带 `X-CF-Token`。',
      usageTitle: '配额与调用',
      exampleTitle: '接入示例',
      createKeyLabel: '新 Key 名称',
      createKeyAction: '生成新 API Key',
      planLabel: '当前套餐',
      sinceLabel: '加入时间',
      quotaLabel: '月度额度',
      requestLabel: '本月请求量',
      checkoutAction: '联系 Telegram 开通',
      portalAction: '管理年费订阅',
      membershipStatus: '会员状态',
      supportTitle: '联系支持',
      supportDescription: '如果你需要开通 VIP、续费、迁移账号、批量授权或部署协助，可以直接通过 Telegram 联系 @socs_sup366。',
      adminTitle: '超级管理员面板',
      adminDescription: '被列入 `SUPER_ADMIN_EMAILS` 的账号登录后，可以手动创建或升级 Super VIP 账号。',
      superVipBadgeDescription: 'Super VIP 账号由超级管理员手动授予，不需要自助支付。',
      superVipEmail: 'Super VIP 邮箱',
      superVipName: 'Super VIP 姓名',
      superVipCompany: '公司 / 团队',
      superVipPassword: '初始密码',
      superVipAction: '创建或升级 Super VIP',
      superVipHint: '如果邮箱已存在，会直接升级为 Super VIP；如果不存在，则创建新账号并赋予 Super VIP。',
      passwordResetTitle: '重置会员密码',
      passwordResetDescription: '可直接为现有会员设置新密码，尤其适合修复旧版 210000 迭代 PBKDF2 账号的登录问题。',
      resetMemberEmail: '会员邮箱',
      resetMemberPassword: '新密码',
      resetMemberPasswordAction: '重置会员密码',
      legacyPasswordHint: '如果某个旧账号登录时报 legacy password hash 或 PBKDF2 iterations 错误，可以在这里直接重置。',
      latestKeyTitle: '新生成的 API Key',
      latestKeyHint: '完整 Key 只显示一次，请立即保存。',
      emptyKeys: '还没有 API Key。联系 Telegram 开通 VIP 后可生成并交给脚本或系统使用。',
      revokeAction: '吊销 Key',
      apiLockedTitle: '当前账号还不是有效 VIP',
      apiLockedDescription: '联系 Telegram 开通年费或终身 VIP 后，即可生成 API Key 并调用所有 `/api/v1/*` 接口。',
      tokenLockedDescription: '只有有效 VIP 才能把 Cloudflare Token 加密保存到会员中心；如需开通请联系 Telegram。',
      tokenPrivacyTitle: '隐私边界',
      tokenPrivacyDescription:
        '网页控制台模式不会把普通用户的 Cloudflare Token 记入数据库。只有你主动在会员中心保存专用 Token 时，系统才会以加密形式写入会员凭证表。',
      memberBenefits: [
        '公开网页模式和会员 API 模式已经拆开，适合既做前台工具站，也做后端服务。',
        '会员 API 支持两种用法：每次请求带 Cloudflare Token，或在会员中心保存后直接请求平台接口。',
        'VIP 开通与续费改为 Telegram 人工处理，不再走 Stripe 自助支付。',
      ],
      statuses: {
        active: '有效',
        lifetime: '终身',
        past_due: '待付款',
        inactive: '未开通',
      },
      planNames: {
        free: 'Free Web',
        vip_yearly: 'VIP Yearly',
        vip_lifetime: 'VIP Lifetime',
        super_vip: 'Super VIP',
      },
    },
    docs: {
      title: '在线 API 文档',
      description: '所有会员接口都带参数说明、返回示例，以及 PHP / Python 代码片段。',
      searchPlaceholder: '搜索接口、路径或关键词',
      authTitle: '认证方式',
      authDescription:
        '平台 API 采用双层认证。必须使用会员 API Key；Cloudflare 凭证则支持两种方式：每次通过 `X-CF-Token` / `X-CF-Key + X-CF-Email` 传入，或先在会员中心加密保存 Cloudflare Token。',
      headersTitle: '推荐请求头',
      codeLabel: '代码示例语言',
      noResult: '没有匹配的接口，试试搜索 DNS、SSL、Workers 等关键词。',
      authHeaders: [
        'Authorization: Bearer YOUR_MEMBER_API_KEY',
        'X-CF-Token: YOUR_CLOUDFLARE_TOKEN',
        'Content-Type: application/json',
        '如果已在会员中心保存 Token，可省略 X-CF-Token',
      ],
      codeTabs: {
        python: 'Python',
        php: 'PHP',
      },
    },
    geo: {
      title: 'GEO 说明',
      description: '这是一套把 Cloudflare 操作能力做成公开工具站和会员 API 服务的系统，既能给终端用户直接使用，也能给开发者二次集成。',
      badge: '系统定位 / 使用边界 / 价值说明',
      sections: [
        {
          title: '这个系统是什么',
          points: [
            '它是一个 Cloudflare 自动化平台，前台提供可直接操作的网页控制台，后台提供会员 API 能力。',
            '公开部分负责解释产品、展示价格、提供文档和转化会员；控制台部分负责具体的 Cloudflare 管理动作。',
          ],
        },
        {
          title: '它给普通用户带来的便利',
          points: [
            '不需要注册账号就能直接在网页里完成 DNS、SSL、安全、Workers 等常用操作。',
            '普通用户的 Cloudflare Token 默认只保存在浏览器本地，不会被写入会员数据库。',
          ],
        },
        {
          title: '它给 VIP 会员带来的便利',
          points: [
            '开通 VIP 后可以生成自己的 API Key，调用平台整理好的全部接口。',
            '可以自己在每个请求里带 Cloudflare Token，也可以在会员中心加密保存专用 Token，减少重复传参。',
          ],
        },
        {
          title: '为什么这样设计',
          points: [
            '把“游客网页直用”和“会员 API 自动化”拆开，既降低首次使用门槛，也更适合做长期付费产品。',
            '文档、会话、API 门面和 Cloudflare 资源操作都放在一个 Pages 项目里，部署和维护更清晰。',
          ],
        },
      ],
      faqTitle: '常见问题',
      faqs: [
        {
          q: '普通用户一定要注册吗？',
          a: '不需要。网页控制台可以直接使用，注册只针对会员 API 能力。',
        },
        {
          q: '普通模式会保存我的 Cloudflare Token 吗？',
          a: '不会。普通网页模式只在浏览器本地保存配置，不会写入会员数据库。',
        },
        {
          q: 'VIP 会员可以不保存 Token 直接调 API 吗？',
          a: '可以。你可以像文档示例一样，每次请求都带 `X-CF-Token`。',
        },
        {
          q: '这个项目能不能直接上线到 Cloudflare Pages？',
          a: '可以。`web/` 目录已经是适合 Pages 的全栈结构，包含前端页面和 Pages Functions API。',
        },
      ],
      ctaTitle: '需要网页直接用，就进控制台；需要 API 自动化，就联系 Telegram 开通 VIP',
      ctaDescription: '这就是整个系统最清晰的分层：公开可用的网页工具 + 人工开通的统一 API。',
    },
    console: {
      dashboard: '控制台总览',
      config: 'Cloudflare 配置',
      dns: 'DNS 管理',
      dnsBatch: '批量 DNS',
      ssl: 'SSL / TLS',
      sslBatch: '批量 SSL',
      security: '安全规则',
      rules: '规则管理',
      wwwRedirect: 'WWW 跳根域',
      domainBatch: '批量新增域名',
      workersBatch: '批量绑定 Worker',
      selectDomain: '选择域名',
      searchDomain: '搜索域名...',
      noDomain: '暂无域名',
      loading: '加载中...',
      settings: '设置',
    },
  },
  'en-US': {
    common: {
      brand: 'Cloudflare Tools',
      brandTag: 'Public web console + VIP API automation platform',
      console: 'Console',
      docs: 'API Docs',
      pricing: 'Pricing',
      memberCenter: 'Member Center',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      getStarted: 'Get Started',
      viewDocs: 'View Docs',
      launchConsole: 'Open Console',
      save: 'Save',
      cancel: 'Cancel',
      search: 'Search',
      generate: 'Generate',
      revoke: 'Revoke',
      copy: 'Copy',
      active: 'Active',
      recommended: 'Recommended',
      all: 'All',
      footerProduct: 'Product',
      footerWorkspace: 'Workspace',
      contactUs: 'Contact',
      telegram: 'Telegram',
      telegramAction: 'Contact on Telegram',
      localModeNotice:
        'Public users can use the web console without registering, and Cloudflare tokens stay in the browser by default. VIP members may optionally save a dedicated Cloudflare token in encrypted form for API access.',
    },
    nav: {
      home: 'Home',
      pricing: 'Pricing',
      docs: 'Docs',
      geo: 'GEO',
      member: 'Member Center',
      console: 'Console',
    },
    home: {
      badge: 'Bilingual / Public Web Use / VIP API',
      title: 'Turn this Cloudflare operations toolkit into a bilingual product with public web access and paid API automation',
      description:
        'Anyone can use the web console without registering, while VIP members can automate every workflow through API keys and either send Cloudflare credentials per request or store them securely for server-side calls.',
      primaryCta: 'Open Console',
      secondaryCta: 'Read API Docs',
      stats: [
        { label: 'Public web mode', value: 'No signup' },
        { label: 'Example languages', value: 'PHP / Python' },
        { label: 'VIP access', value: 'Telegram contact' },
      ],
      sections: {
        featuresTitle: 'Core capabilities',
        features: [
          {
            title: 'Public web console',
            description: 'Users can operate DNS, SSL, security, Workers, and related workflows from the browser without creating an account.',
          },
          {
            title: 'Cloudflare credentials stay local by default',
            description: 'In public web mode, Cloudflare tokens are stored only in the browser and are not written into your membership database.',
          },
          {
            title: 'VIP members get full API access',
            description: 'Paid members can generate API keys for the full `/api/v1/*` surface and choose per-request or stored Cloudflare tokens.',
          },
          {
            title: 'Complete online documentation',
            description: 'Endpoints are grouped by Zones, DNS, SSL/TLS, Security, Workers, and Pages with PHP and Python examples.',
          },
        ],
        productKicker: 'Platform shape',
        productTitle: 'Public on the front end, programmable on the back end',
        productDescription:
          'The system now supports both browser-first operations and member-only API automation. The public layer handles onboarding and direct use, while the member layer handles manual activation, API keys, and encrypted credential storage.',
        productBullets: [
          'Public site: home, pricing, docs, GEO, and member center',
          'Public web mode: Cloudflare credentials remain browser-local',
          'VIP API mode: members can store a dedicated token and call every endpoint',
        ],
        referenceKicker: 'API surface',
        docsTitle: 'A unified Cloudflare API facade',
        docsDescription:
          'You no longer need to document authentication and examples separately for each Cloudflare workflow. The platform already organizes capabilities, parameters, and code samples in one place.',
        referenceBullets: [
          'Zones and account discovery',
          'DNS CRUD and batch operations',
          'SSL / TLS modes and policies',
          'Security / WAF / Workers / Pages',
        ],
      },
      launchKicker: 'Deployment model',
      ctaTitle: 'Ready for Cloudflare Pages deployment',
      ctaDescription:
        'The public pages, member flow, Pages Functions API facade, D1, and KV are already wired together. Once real secrets are configured, `web/` can ship as a Cloudflare Pages full-stack app, with VIP activation handled through Telegram.',
      searchKicker: 'SEO / GEO signals',
      searchTitle: 'Make the product easier for search engines and AI summaries to understand',
      searchDescription:
        'The public pages now state more clearly that this is a Cloudflare management platform for DNS, SSL/TLS, security rules, country access control, Workers, Pages, and API automation.',
      searchTerms: [
        'Cloudflare management toolkit and public web console',
        'Cloudflare DNS management, batch DNS, and domain operations',
        'Cloudflare SSL / TLS settings and rollout workflows',
        'Cloudflare security rules, WAF, and country access control',
        'Cloudflare Workers bindings, Pages deployment, and member API automation',
      ],
      useCasesKicker: 'Use cases',
      useCasesTitle: 'Fit for agencies, SaaS, operations teams, and batch workflows',
      useCases: [
        {
          title: 'Manage multiple Cloudflare domains in one place',
          description: 'Useful for teams that handle DNS, SSL/TLS, security, and Workers routes across many sites.',
        },
        {
          title: 'Handle common Cloudflare tasks from a browser',
          description: 'Public users can open the web console directly and handle records, certificates, and baseline security settings.',
        },
        {
          title: 'Connect Cloudflare operations to scripts or internal systems',
          description: 'VIP members can use API keys and the unified API surface to automate DNS, SSL, security, and Workers workflows.',
        },
      ],
      faqKicker: 'FAQ',
      faqTitle: 'Four questions people ask most often',
      faqs: [
        {
          q: 'What does Cloudflare Tools actually do?',
          a: 'It helps manage Cloudflare DNS, SSL/TLS, security rules, country access control, Workers routes, Pages-related workflows, and member API automation.',
        },
        {
          q: 'Can users access it without creating an account?',
          a: 'Yes. The web console is open to public users. Registration is only needed for API keys, quotas, and encrypted token storage.',
        },
        {
          q: 'Is it optimized for Chinese-speaking users?',
          a: 'Yes. The public pages, docs, and product descriptions are optimized for Chinese SEO and still keep bilingual support available.',
        },
        {
          q: 'Does it support batch Cloudflare operations?',
          a: 'Yes. The project covers batch DNS, batch SSL/TLS, batch domain onboarding, batch Workers bindings, and security rule workflows.',
        },
      ],
    },
    pricing: {
      title: 'Pricing',
      description: 'The web console is open to public users. API access is reserved for VIP members. For activation or renewal, contact us on Telegram.',
      plans: [
        {
          id: 'free',
          name: 'Free Web',
          price: '$0',
          blurb: 'Best for browser-based Cloudflare work without signup or server-side token storage.',
          features: ['Use the web console without registration', 'Cloudflare tokens stay in the browser by default', 'Good for manual DNS / SSL / security operations', 'No member API access included'],
          badge: '',
          ctaLabel: 'Open the Console',
          ctaTo: '/console',
        },
        {
          id: 'vip_yearly',
          name: 'VIP Yearly',
          price: '$130 / year',
          blurb: 'Best for teams or developers who need stable API access and repeatable automation.',
          features: ['Generate member API keys for every endpoint', 'Send Cloudflare credentials per request', 'Optionally store an encrypted Cloudflare token', 'Online docs with PHP / Python examples'],
          badge: 'recommended',
          ctaLabel: 'Contact on Telegram',
          ctaTo: '/member',
        },
        {
          id: 'vip_lifetime',
          name: 'VIP Lifetime',
          price: '$600',
          blurb: 'Best for long-term operations, agencies, and high-volume automation that should not renew yearly.',
          features: ['Lifetime access to member API capabilities', 'Encrypted Cloudflare token storage included', 'Good for long-running scripts, SaaS, or agency workflows', 'No renewal management'],
          badge: '',
          ctaLabel: 'Contact on Telegram',
          ctaTo: '/member',
        },
      ],
    },
    member: {
      title: 'Member Center',
      description: 'VIP membership is for API access and does not replace the public web console.',
      registerTitle: 'Create a member account',
      loginTitle: 'Sign in',
      name: 'Name',
      company: 'Company / Team',
      email: 'Email',
      password: 'Password',
      plan: 'Target plan',
      registerAction: 'Create member account',
      loginAction: 'Sign in',
      localMode: 'Anyone can use the web console directly. Registration is only needed when you want VIP API access.',
      dashboardTitle: 'Member Dashboard',
      billingTitle: 'VIP activation and renewal',
      billingDescription: 'Choose your target plan, then contact Telegram for manual activation or renewal. Stripe self-serve checkout is disabled on this deployment.',
      apiKeysTitle: 'API Key Management',
      savedTokenTitle: 'Stored Cloudflare Token',
      savedTokenDescription:
        'This credential is for VIP API mode only. It is separate from the browser-local console configuration and is encrypted before being written to the member credential table.',
      savedTokenLabel: 'Cloudflare API Token',
      savedTokenAlias: 'Credential label',
      savedTokenPlaceholder: 'Paste your Cloudflare API token',
      savedTokenAliasPlaceholder: 'For example: Production Account Token',
      saveTokenAction: 'Save Encrypted Token',
      deleteTokenAction: 'Delete Stored Token',
      savedTokenEmpty: 'No dedicated Cloudflare token has been saved yet. The API still works if you send `X-CF-Token` on each request.',
      savedTokenHint: 'Once stored, member API requests can omit `X-CF-Token`.',
      usageTitle: 'Usage & quota',
      exampleTitle: 'Integration Example',
      createKeyLabel: 'New key name',
      createKeyAction: 'Generate API key',
      planLabel: 'Current plan',
      sinceLabel: 'Member since',
      quotaLabel: 'Monthly quota',
      requestLabel: 'Requests this month',
      checkoutAction: 'Contact on Telegram',
      portalAction: 'Manage yearly subscription',
      membershipStatus: 'Membership status',
      supportTitle: 'Contact Support',
      supportDescription: 'For VIP activation, renewals, account migration, bulk authorization, or deployment help, contact Telegram @socs_sup366.',
      adminTitle: 'Super Admin Panel',
      adminDescription: 'Any account listed in `SUPER_ADMIN_EMAILS` can sign in and manually create or upgrade a Super VIP member.',
      superVipBadgeDescription: 'Super VIP accounts are granted manually by a super admin and do not require self-serve checkout.',
      superVipEmail: 'Super VIP email',
      superVipName: 'Super VIP name',
      superVipCompany: 'Company / Team',
      superVipPassword: 'Initial password',
      superVipAction: 'Create or upgrade Super VIP',
      superVipHint: 'If the email already exists, the account will be upgraded to Super VIP. Otherwise a new account will be created and granted Super VIP access.',
      passwordResetTitle: 'Reset member password',
      passwordResetDescription: 'Set a new password for an existing member account. This is especially useful for older 210000-iteration PBKDF2 accounts that can no longer sign in on the current runtime.',
      resetMemberEmail: 'Member email',
      resetMemberPassword: 'New password',
      resetMemberPasswordAction: 'Reset member password',
      legacyPasswordHint: 'If an older account reports a legacy password hash or PBKDF2 iterations error, reset it here.',
      latestKeyTitle: 'New API Key',
      latestKeyHint: 'The full key is shown only once. Save it immediately.',
      emptyKeys: 'No API keys yet. Once VIP is activated through Telegram, generate keys for scripts or integrations.',
      revokeAction: 'Revoke',
      apiLockedTitle: 'This account is not an active VIP yet',
      apiLockedDescription: 'Contact Telegram to activate VIP Yearly or VIP Lifetime before generating API keys and calling the full `/api/v1/*` surface.',
      tokenLockedDescription: 'Only active VIP members can store a Cloudflare token in the member center. Contact Telegram to activate access.',
      tokenPrivacyTitle: 'Privacy boundary',
      tokenPrivacyDescription:
        'Public web mode never writes ordinary users’ Cloudflare tokens to the database. A Cloudflare token is stored only when a VIP member explicitly saves one in the member center.',
      memberBenefits: [
        'Public web use and VIP API automation are now clearly separated, making the project suitable as both a tool site and a backend service.',
        'The member API supports two usage patterns: send Cloudflare credentials per request, or store one securely in the member center.',
        'VIP activation and renewals are now handled manually through Telegram instead of Stripe self-serve checkout.',
      ],
      statuses: {
        active: 'Active',
        lifetime: 'Lifetime',
        past_due: 'Past due',
        inactive: 'Inactive',
      },
      planNames: {
        free: 'Free Web',
        vip_yearly: 'VIP Yearly',
        vip_lifetime: 'VIP Lifetime',
        super_vip: 'Super VIP',
      },
    },
    docs: {
      title: 'Online API Reference',
      description: 'Every member-facing endpoint includes parameters, response examples, and PHP / Python code snippets.',
      searchPlaceholder: 'Search endpoints, paths, or keywords',
      authTitle: 'Authentication model',
      authDescription:
        'The platform API uses dual authentication. A member API key is always required. Cloudflare credentials can either be sent through `X-CF-Token` / `X-CF-Key + X-CF-Email`, or stored securely in the member center first.',
      headersTitle: 'Recommended headers',
      codeLabel: 'Example language',
      noResult: 'No endpoints matched. Try searching for DNS, SSL, Workers, or Security.',
      authHeaders: [
        'Authorization: Bearer YOUR_MEMBER_API_KEY',
        'X-CF-Token: YOUR_CLOUDFLARE_TOKEN',
        'Content-Type: application/json',
        'If a token is already stored in the member center, X-CF-Token can be omitted',
      ],
      codeTabs: {
        python: 'Python',
        php: 'PHP',
      },
    },
    geo: {
      title: 'GEO Overview',
      description: 'This system turns Cloudflare operations into both a public tool site and a member API service, so end users can work directly in the browser while developers integrate the same workflows programmatically.',
      badge: 'Positioning / boundaries / value',
      sections: [
        {
          title: 'What this system is',
          points: [
            'It is a Cloudflare automation platform with a browser-first public console and a member-only API layer.',
            'The public side explains the product, exposes pricing, documents the API, and converts members, while the console handles the actual Cloudflare operations.',
          ],
        },
        {
          title: 'What it gives ordinary users',
          points: [
            'Users can operate DNS, SSL, security, Workers, and related tasks without registering first.',
            'In public web mode, Cloudflare tokens stay in the browser and are not written to the member database.',
          ],
        },
        {
          title: 'What it gives VIP members',
          points: [
            'VIP members can generate their own API keys and call the full platform API.',
            'They can either send a Cloudflare token on every request or store a dedicated encrypted token in the member center.',
          ],
        },
        {
          title: 'Why the system is designed this way',
          points: [
            'Separating public web usage from paid API automation lowers the first-use barrier while preserving a strong subscription product.',
            'Documentation, sessions, the API facade, and Cloudflare resource actions all live in one Pages project for a cleaner launch path.',
          ],
        },
      ],
      faqTitle: 'Frequently asked questions',
      faqs: [
        {
          q: 'Do ordinary users have to register?',
          a: 'No. Registration is only required for member API access. The web console can be used directly.',
        },
        {
          q: 'Does public mode store my Cloudflare token?',
          a: 'No. Public web mode keeps the token in browser storage only and does not write it into the member database.',
        },
        {
          q: 'Can VIP members call the API without storing a token first?',
          a: 'Yes. They can follow the docs and send `X-CF-Token` on every request.',
        },
        {
          q: 'Can this project go live on Cloudflare Pages?',
          a: 'Yes. The `web/` directory already matches a Pages-friendly full-stack structure with public pages and Pages Functions.',
        },
      ],
      ctaTitle: 'Use the console for direct browser operations, or contact Telegram to activate VIP automation',
      ctaDescription: 'That is the clearest product split: a public Cloudflare tool site plus a manually activated unified API.',
    },
    console: {
      dashboard: 'Dashboard',
      config: 'Cloudflare Config',
      dns: 'DNS',
      dnsBatch: 'Batch DNS',
      ssl: 'SSL / TLS',
      sslBatch: 'Batch SSL',
      security: 'Security',
      rules: 'Rules',
      wwwRedirect: 'WWW Redirect',
      domainBatch: 'Batch Domains',
      workersBatch: 'Batch Workers',
      selectDomain: 'Select Domain',
      searchDomain: 'Search domains...',
      noDomain: 'No domains',
      loading: 'Loading...',
      settings: 'Settings',
    },
  },
};
